import { t } from '@/utils/i18n'
import styles from './OrderResult.module.less'
import { Image } from 'antd-mobile'
import defaultImg from '@/assets/img/default/default-avatar.png'
import { useCorpInfoStore, useCorpSettingStore } from '@/stores'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { routesMap, common } from '@/utils'
import localStorage from "@/utils/localStorage";

const { getLocalStorage } = localStorage
const { hasHomeModule } = common

function OrderResult() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { corpInfo } = useCorpInfoStore()
  const { corpSetting } = useCorpSettingStore()
  const ossRoot = getLocalStorage('ossRoot')
  const {
    corpName,
    cloudStoreContactPhone,
    staffAvatar,
    staffEmail,
    staffName,
    staffPhone,
  } = corpInfo
  const { singleOrderMaxAmount } = corpSetting
  const orderId = searchParams.get('orderid') || searchParams.get('orderId')
  const amount = searchParams.get('amount')
  const staffAvatarUrl = staffAvatar ? ossRoot + staffAvatar : defaultImg

  // 回到首页
  async function handleEnterStore() {
    const homeModule = await hasHomeModule();
    if (homeModule) {
      navigate(routesMap.App, {
        replace: true,
      })
    } else {
      navigate(routesMap.Products, {
        replace: true,
      })
    }
  }

  return (
    <div className={styles['page-wrap']}>
      <h1 className={styles['title']}>{t('下单成功')}</h1>
      <div className={styles['desc']}>
        {(amount || 0) >= singleOrderMaxAmount
          ? t('订单超过1亿，店长会主动联系您协助完成交易')
          : t('已指派专门的销售代表与您跟进')}
      </div>
      <div className={styles['card-wrap']}>
        <div className={styles['hd']}>
          <div className={styles['img-wrap']}>
            <Image src={staffAvatarUrl} fit="fill" />
          </div>
          <p className={styles['name']}>{staffName || corpName}</p>
          <p className={styles['tel']}>
            <a href={`tel:${staffPhone || cloudStoreContactPhone}`}>
              {staffPhone || cloudStoreContactPhone}
            </a>
          </p>
          <p className={styles['email']}>{staffEmail}</p>
          <a className={styles['btn-wrap']} href={`tel:${staffPhone || cloudStoreContactPhone}`}>
            {t('联系我们')}
          </a>
        </div>
        <div className={styles['ft']}>
          <div className={styles['btn-list']}>
            <button
              className={styles['btn-item']}
              onClick={() =>
                navigate(
                  `/order/detail/${orderId}?fromRouterName=${routesMap.OrderResult}`,
                  {
                    replace: true,
                  }
                )
              }
            >
              {t('查看订单')}

              {/* View Order */}
            </button>
            <button
              className={styles['btn-item']}
              onClick={handleEnterStore}
            >
              {t('首页')}

              {/* Homepage */}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderResult
